



























import Vue from 'vue'
import {Component, Mixins, Prop, Ref} from 'vue-property-decorator'
import JdhAttachedModalPopup from "@/design-system/shared/JdhAttachedModalPopup.vue"
import {ActiveProvide} from "@/support/reactive"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import {
    AcquireFirstFocus,
    AcquireLastFocus
} from "@/design-system/utilities/FocusHelper"

/**
 * @status stable
 * @published 4.6.0
 * @changelog 4.6.0 Published.
 * @changelog 4.6.2 Fix bug where clicking the trigger while the menu is open does not close the menu.
 * @changelog 4.12.0 Add cog menu option.
 * @changelog 4.17.0 Update visuals.
 */
@Component({
    components: {JdhAttachedModalPopup}
})
export default class JdsDropdownMenu extends Mixins(UniqueIdMixin) {
    open = false
    @Prop() label!: string
    @Prop({type: Boolean, default: false}) cog!: boolean
    @Ref() triggerEl!: HTMLElement
    @Ref() menuEl!: HTMLElement
    @ActiveProvide('jds.dropdown-menu.bus') bus: Vue|null = null

    // used to queue up an action once the menu is opened.
    next: null|'first'|'last' = null

    // test

    beforeMount() {
        this.bus = new Vue()
        this.bus.$on('dismiss', () => {
            this.triggerEl.focus()
            this.open = false
        })
    }

    openMenu() {
        // close if already open.
        this.open = !this.open
        if (this.open) {
            this.next = 'first'
        }
    }

    handleHotkeys(e: KeyboardEvent) {
        if (e.key === 'ArrowDown') {
            this.open = true
            this.next = 'first'
            e.preventDefault()
        }
        if (e.key === 'ArrowUp') {
            this.open = true
            this.next = 'last'
            e.preventDefault()
        }
    }

    openCallback() {
        if (this.next === 'first') {
            AcquireFirstFocus(this.menuEl)
        }
        if (this.next === 'last') {
            AcquireLastFocus(this.menuEl)
        }
        this.next = null
    }

    handleFocusLoss(e:  FocusEvent) {
        if (!e.relatedTarget || !this.menuEl) return
        if (!this.menuEl.contains(e.relatedTarget as HTMLElement) && this.triggerEl !== e.relatedTarget) {
            this.triggerEl.focus()
            this.open = false
        }
    }

    get classes() {
        return {
            'jdsc-dropdown-menu__trigger--cog': this.cog,
            'jdsc-dropdown-menu__trigger--open': this.open,
        }
    }
}
